import React from 'react';
import { connect } from 'react-redux';
import { translator } from 'mage-i18n';
import {
  ButtonQuaternary,
  Separator,
  SpacerHorizontal,
  SpacerVertical,
  Typography,
} from '@klarna/bubble-ui';
import { Column, Row, withResponsive } from 'mage-components';

import { LinkWithoutHref } from './LinkWithoutHref';

type SummarySectionProps = {
  isDesktop: boolean;
  children: React.ReactNode;
  onEdit?: () => void;
  t: (key: string) => string;
  title: string;
  subtitle: string;
  titleLink?: string;
  onTitleLinkClick?: () => void;
};

const SummarySection = ({
  isDesktop,
  children,
  onEdit,
  t,
  title,
  subtitle,
  titleLink,
  onTitleLinkClick,
}: SummarySectionProps) => (
  <>
    {(title || onEdit) && (
      <>
        <Row>
          <Column columns={{ mobile: 9 }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography textToken="text-style/headings/blocks/bold/tertiary">{title}</Typography>
              <SpacerHorizontal spaceToken="space/150" />
              <Typography textToken="text-style/text/paragraphs/tiny/regular">
                {subtitle}
              </Typography>
              {titleLink && (
                <>
                  <SpacerHorizontal spaceToken="space/150" />
                  <div style={{ alignSelf: isDesktop ? 'flex-end' : undefined, marginBottom: 3 }}>
                    <LinkWithoutHref
                      isUnderlined
                      colorToken="colors/text/neutral"
                      onPress={onTitleLinkClick}
                    >
                      {titleLink}
                    </LinkWithoutHref>
                  </div>
                </>
              )}
            </div>
          </Column>
          {onEdit && (
            <Column columns={{ mobile: 3 }} alignItems={{ mobile: 'flex-end' }}>
              <ButtonQuaternary size="small" onClick={onEdit}>
                {t(`products-fe.containers.application_summary.buttons.edit`)}
              </ButtonQuaternary>
            </Column>
          )}
        </Row>
        <SpacerVertical spaceToken="space/100" />
        <Separator />
      </>
    )}
    <SpacerVertical spaceToken="space/150" />
    {children}
  </>
);

export default connect(state => ({
  t: translator(state),
}))(withResponsive(SummarySection));
